var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"py-3 mt-8",attrs:{"dark":"","color":"primary","padless":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }